import React from "react";
import {
  List,
  DatagridConfigurable,
  TextField,
  TopToolbar,
  SelectColumnsButton,
  FilterButton,
  ExportButton,
  CreateButton,
  useDefaultTitle,
  useListContext,
  RaRecord,
  Identifier,
  FunctionField,
  ChipField,
} from "react-admin";

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
    <SelectColumnsButton />
    <ExportButton />
    <CreateButton label="Create Channel" to="/channels/create" />
  </TopToolbar>
);

const ChannelsTitle = () => {
  const title = useDefaultTitle();
  const { defaultTitle } = useListContext();
  return (
    <>
      <title>{`${title} - Channels`}</title>
      <span>Channels</span>
    </>
  );
};

const ThumbnailField = ({ record }: { record?: RaRecord }) => {
  const url = record?.assets?.[0]?.url;
  if (!url) return null;
  return (
    <img
      src={url}
      alt={record?.title || ""}
      style={{ width: 50, height: 50, objectFit: "cover", borderRadius: 4 }}
    />
  );
};

const ChannelsList = () => (
  <List
    resource="sync/override/channels"
    perPage={25}
    actions={<ListActions />}
    filters={[]}
    title={<ChannelsTitle />}
    sort={{ field: "channelId", order: "ASC" }}
  >
    <DatagridConfigurable
      rowClick={(id: Identifier) => `/channels/${id}/edit`}
      bulkActionButtons={false}
    >
      <FunctionField
        label="Thumbnail"
        render={(record: RaRecord) => <ThumbnailField record={record} />}
      />
      <TextField source="title" />
      <TextField source="channelId" label="Channel ID" />
      <FunctionField
        label="Action Type"
        render={(record: RaRecord) => {
          const value = record.actionType || "disabled";
          return <ChipField record={{ value }} source="value" />;
        }}
      />
      <TextField source="streamUrl" label="Stream URL" />
      <FunctionField
        label="Priority"
        render={(record: RaRecord) => record.priority ?? 0}
      />
      <FunctionField
        label="Visibility"
        source="isHidden"
        render={(record: RaRecord) => {
          const value = record.isHidden ? "hidden" : "public";
          return <ChipField record={{ value }} source="value" />;
        }}
      />
    </DatagridConfigurable>
  </List>
);

export default ChannelsList;
